export const GET_SCHOOLS_DROPDOWN = 'GET_SCHOOLS_DROPDOWN';
export const SCHOOLS_LOADING = 'SCHOOLS_LOADING';



// WEBPACK FOOTER //
// ./src/features/Schools/types.js